import { ActivityBuilderPrintStaticImage } from 'approot/activity-builder/print/activity-builder-print-image';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { getPrintImage } from '../shared/logic/get-print-image';
import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { ViewProps } from './gif.constants';
import { ImageContainer, ImageViewWrapper } from '../image/image.style';

const GifPrint = ({
  properties: { image, printImageUrls, dimensionData },
}: ViewProps) => {
  const imageUrl = getPrintImage(printImageUrls);

  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl,
  });

  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageContainer $fullBorderRadius>
          <ImageViewWrapper ref={setContainerElement}>
            <ActivityBuilderPrintStaticImage
              imageUrl={imageUrl}
              imageDimensions={imageDimensions}
              altText={image?.alt || ''}
            />
          </ImageViewWrapper>
        </ImageContainer>
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};
export default GifPrint;
